import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c3690584"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pagination" };
const _hoisted_2 = { class: "pagination-lines" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "line" }, null, -1));
const _hoisted_5 = [
    _hoisted_4
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", {
            class: "pagination-counter",
            style: _normalizeStyle({ transform: `translateY(${-1 + _ctx.currentPageIndex * 8}px)` })
        }, _toDisplayString(_ctx.addZero(_ctx.currentPage)) + "/" + _toDisplayString(_ctx.addZero(_ctx.numberOfPages)), 5),
        _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfPages, (el, ind) => {
                return (_openBlock(), _createElementBlock("div", {
                    onClick: ($event) => (_ctx.onClick(ind)),
                    class: _normalizeClass(["line-wrapper", { active: ind === _ctx.currentPageIndex }]),
                    key: ind
                }, _hoisted_5, 10, _hoisted_3));
            }), 128))
        ])
    ]));
}
